module.exports = __webpack_public_path__ + "static/media/S (91).f12a8f2f.jpg";